
  export default {
    props: {
      message: String
    },
    data() {
      return {
        count: 0
      }
    },
    methods: {
      incrementCount() {
        this.count++;
      }
    }
  }
